module.exports = __webpack_public_path__ + "static/media/faq-how-work.e351857d.svg";